import { rootProtectedPath, services } from "data/authData";
import MoveToInboxRounded from "@mui/icons-material/MoveToInboxRounded";
import MemoryRounded from "@mui/icons-material/MemoryRounded";
import PsychologyRounded from "@mui/icons-material/PsychologyRounded";
import UploadFileRounded from "@mui/icons-material/UploadFileRounded";
import HistoryRounded from "@mui/icons-material/HistoryRounded";
import CompareArrowsRoundedIcon from "@mui/icons-material/CompareArrowsRounded";
import axios from "axios";

export const replenishmentDrawerElements = {
	replenishment: {
		name: "REPLENISHMENT",
		key: "replenishment",
		display: true,
		icon: <MoveToInboxRounded />,
		types: {
			repl_logics: {
				name: "Logics",
				key: "repl_logics",
				display: true,
				icon: <PsychologyRounded />,
			},
			execute_logics: {
				name: "Execute Logics",
				key: "execute_logics",
				display: true,
				icon: <MemoryRounded />,
			},
			repl_upload_files: {
				name: "Upload Files",
				key: "repl_upload_files",
				display: true,
				icon: <UploadFileRounded />,
			},
			repl_selected_logic: {
				name: "Selected Logic",
				key: "repl_selected_logic",
				display: false,
			},
			// repl_jobs: {
			// 	name: "Logs",
			// 	key: "repl_jobs",
			// 	display: true,
			// 	icon: <HistoryRounded />,
			// },
			repl_selected_job: {
				name: "Selected Job",
				key: "repl_selected_job",
				display: false,
			},
		},
	},
	ist: {
		name: "IST",
		key: "ist",
		display: true,
		icon: <CompareArrowsRoundedIcon />,
		types: {
			ist_profiles: {
				name: "Logics",
				key: "ist_profiles",
				display: true,
				icon: <PsychologyRounded />,
			},
			ist_summary: {
				name: "Summary",
				key: "ist_summary",
				display: true,
				icon: <MemoryRounded />,
			},
			ist_upload_files: {
				name: "Upload Files",
				key: "ist_upload_files",
				display: true,
				icon: <UploadFileRounded />,
			},
			ist_selected_logic: {
				name: "Selected Logic",
				key: "ist_selected_logic",
				display: false,
			},
			ist_logs: {
				name: "Logs",
				key: "ist_logs",
				display: true,
				icon: <HistoryRounded />,
			},
		},
	},
};

export const selectOptKeyName = "select_options";
export const replenishmentParamName = "tab";

export const allOption = "ALL";

export const allLogicProfilesPath = `${rootProtectedPath}/${services.replenishment.path}/${replenishmentDrawerElements.replenishment.key}/${replenishmentDrawerElements.replenishment.types.repl_logics.key}`;
export const replAllLogicProfilesPath = `${rootProtectedPath}/${services.replenishment.path}/${replenishmentDrawerElements.replenishment.key}/${replenishmentDrawerElements.replenishment.types.repl_logics.key}`;
export const replExecuteLogicsPath = `${rootProtectedPath}/${services.replenishment.path}/${replenishmentDrawerElements.replenishment.key}/${replenishmentDrawerElements.replenishment.types.execute_logics.key}`;
export const replenishmentSelectedProfilePath = `${rootProtectedPath}/${services.replenishment.path}/${replenishmentDrawerElements.replenishment.key}/${replenishmentDrawerElements.replenishment.types.repl_selected_logic.key}`;
export const replenishmentSelectedJobPath = `${rootProtectedPath}/${services.replenishment.path}/${replenishmentDrawerElements.replenishment.key}/${replenishmentDrawerElements.replenishment.types.repl_selected_job.key}`;

export const getFileSignedUrl = async (filePath) => {
	if (!filePath) throw new Error("No File Path Found");
	const {
		data: { result },
	} = await axios.post("/api/replenishment/generate_signed_url", {
		filePath,
	});

	return result.url;
};
